import EquipmentRecipe from "@/components/CookingMode/EquipmentRecipe/EquipmentRecipe";
import { EquipmentType } from "@/types/baseTypes";
import { useGlobalContext } from "@aleksundshantu.com/aunds-utils-react/contexts";
import React from "react";

function RecipeTools({ equipmentList }: { equipmentList: EquipmentType[] }) {
  const { getLabel } = useGlobalContext();
  return (
    <>
      <h3 className="has-text-centered">{getLabel("tools_modal_headline")}</h3>
      <EquipmentRecipe equipmentList={equipmentList} />
    </>
  );
}

export default RecipeTools;
